import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAppUsersByAppId } from '@api/data-security';

export const getCoreDataSecurityAppUsersByAppIdSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAppUsersByAppId',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAppUsersByAppId,
	retainDataOnRequest: true
});
